import { useSearchParams } from "react-router-dom";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PageHeader } from "@/components/shared";
import { OnboardingForms } from "@/components/onboarding-forms/OnboardingForms";
import { AgreementsRegister } from "@/components/documents/AgreementsRegister";

export default function ClientOnboarding() {
  const [params, setParams] = useSearchParams();
  const tab = params.get("tab") || "forms";
  return (
    <div data-testid="client-onboarding-page">
      <PageHeader title="Client Onboarding" subtitle="Client-specific forms, requests, instructions and confidentiality agreements. Our own reusable documents live under MarksMan Documents." />
      <Tabs value={tab} onValueChange={(v) => setParams({ tab: v })}>
        <TabsList className="bg-white border border-slate-200 h-auto p-1 mb-2">
          <TabsTrigger value="forms" data-testid="tab-forms">Forms & Requests</TabsTrigger>
          <TabsTrigger value="nda" data-testid="tab-nda">NDA / CDA</TabsTrigger>
        </TabsList>
        <p className="text-xs text-slate-500 mb-5" data-testid="tab-explainer">
          {tab === "forms" && "Vendor registration forms, supplier questionnaires, declarations, client invoicing instructions and our completed submissions — every record is linked to its client. When a client asks for our PAN, GST, ISO certificate or a policy, link the existing MarksMan document instead of uploading another copy."}
          {tab === "nda" && "Client-specific confidentiality agreements — signed and awaiting signature. Signing status and validity dates are tracked separately; a signed NDA / CDA stays here after onboarding is complete and also appears on the client's Agreements tab."}
        </p>
        <TabsContent value="forms"><OnboardingForms /></TabsContent>
        <TabsContent value="nda"><AgreementsRegister group="nda" testid="nda-register" /></TabsContent>
      </Tabs>
    </div>
  );
}
